import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {ExpressionModel} from '../../expression.model';
import {ContentEditableDirective, LeModalService} from 'common-shared';
import {ExpressionFormulaEditorComponent} from '../expression-formula-editor/expression-formula-editor.component';
import {clone} from "lodash-es";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'mes-web-expression-formula',
  styles: [':host {display: flex; flex: 1 1 auto!important; flex-wrap: wrap !important;}'],
  templateUrl: './expression-formula.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpressionFormulaComponent implements OnInit {

  @Input() expression: ExpressionModel;
  @Output() changed = new EventEmitter<ExpressionModel>();
  @Output() modalEvent = new EventEmitter<'opened' | 'closed'>();
  @Input() name: string;
  @Input() cssClass: string = 'mx-wx-384';
  @Input() readonly: boolean = false;
  @Input() placeholder: string;
  @Input() hasExternalFormula: boolean = true;
  @ViewChild('formula') formulaDirectiveRef?: ContentEditableDirective;
  expression$: BehaviorSubject<ExpressionModel> = new BehaviorSubject<ExpressionModel>(null);

  constructor(private leModalService: LeModalService) {
  }

  ngOnInit() {
    this.expression ??= new ExpressionModel();
    this.expression$.next(this.expression);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.expression && !changes.expression.isFirstChange()) {
      this.expression$.next(changes.expression.currentValue);
    }
  }

  edit() {
    const initialExpression = clone(this.expression);
    const modalRef = this.leModalService.show(ExpressionFormulaEditorComponent, {class: 'modal-lg', initialState: {expression: this.expression, hasExternalFormula: this.hasExternalFormula, readonly: this.readonly}})
    this.modalEvent.emit('opened');
    modalRef.onHide$.subscribe(value => {
      this.modalEvent.emit('closed');
      this.expression$.next(this.expression);
      //this.formulaDirectiveRef.writeValue(this.expression.Formula);
      if (initialExpression.Formula != this.expression.Formula || initialExpression.ExternalFormula != this.expression.ExternalFormula) {
        this.changed.emit(this.expression);
      }
    });
  }

  formatFormula(formula: string, event: ClipboardEvent): string {
    if (window.getSelection) {
      const sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        formula ??= '';
        let pastedText = event.clipboardData.getData('text');
        const newLine = /\n/g;
        const doubleWhiteSpace = /\s\s+/g;
        const nonBreakingWhitespace = /\u00A0/g;
        const range = sel.getRangeAt(0);
        const selectionStartIndex = range.startOffset;
        const selectionEndIndex = selectionStartIndex + sel.toString().length;
        const start = formula.substring(0, selectionStartIndex);
        const end = formula.substring(selectionEndIndex);
        formula = start + pastedText + end;
        formula = formula.replace(newLine, '');
        formula = formula.replace(doubleWhiteSpace, ' ');
        formula = formula.replace(nonBreakingWhitespace, ' ');
        event.preventDefault();
      }
    }
    return formula;
  }
}
